import {connect} from 'react-redux';
import Zusammenfassung from './Zusammenfassung';
import {sendAnmeldungRequest, STATE_IS_TRANSMITTING, STATE_TRANSMISSION_STATUS, STATE_TRANSMISSION_RESULT} from '../../main';
import {push} from 'react-router-redux';
import {BEITRAG_ERSTES_KIND, BEITRAG_GEWSCHISTERKINDER} from "../../constants";

function mapStateToProps(state) {
  return {
    viewportWidth: state.main.get('viewportWidth'),
    parentValue: state.parent,
    childrenValues: state.children,
    transmitting: state.main.get(STATE_IS_TRANSMITTING, false),
    disabled: state.main.get(STATE_TRANSMISSION_STATUS) === 'initial' ? false : true,
    error: state.main.get(STATE_TRANSMISSION_STATUS) === 'error' ? true : false,
    errorText: (typeof state.main.get(STATE_TRANSMISSION_RESULT) === 'string' && state.main.get(STATE_TRANSMISSION_RESULT)) || (state.main.get(STATE_TRANSMISSION_RESULT) && state.main.get(STATE_TRANSMISSION_RESULT).response && state.main.get(STATE_TRANSMISSION_RESULT).response.statusText),
    statusCode: state.main.get(STATE_TRANSMISSION_RESULT) && state.main.get(STATE_TRANSMISSION_RESULT).response && state.main.get(STATE_TRANSMISSION_RESULT).response.status,
    beitragSumme: BEITRAG_ERSTES_KIND + (state.children.size - 1) * BEITRAG_GEWSCHISTERKINDER
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: () => dispatch(sendAnmeldungRequest()),
    onBack: () => dispatch(push(ownProps.previousRoute)),
  }
}

const ConnectedZusammenfassung = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Zusammenfassung);

export default ConnectedZusammenfassung;



// WEBPACK FOOTER //
// ./src/components/zusammenfassung/ZusammenfassungComponent.js